module.exports = __webpack_public_path__ + "img/candidate-azul.55d47ec2.png";